// API 基础配置
export const API_BASE_URL = 'https://chatv2.leytcn.com/api';

// Admin API 路径
export const ADMIN_API = {
    clientUpdatePublish: `${API_BASE_URL}/admin/app_update/publish_app_update.php`,
    clientUpdateList: `${API_BASE_URL}/admin/app_update/list_app_updates.php`,
    // 员工管理
    employee: {
        fetch: `${API_BASE_URL}/admin/employee/fetch`,
        insert: `${API_BASE_URL}/admin/employee/insert`,
        update: `${API_BASE_URL}/admin/employee/update`,
        deldate: `${API_BASE_URL}/admin/employee/deldate`,
        de_employee: `${API_BASE_URL}/admin/employee/de_employee`,
        en_employee: `${API_BASE_URL}/admin/employee/en_employee`,
    },
    // 模板管理
    moban: {
        fetch: `${API_BASE_URL}/admin/moban/fetch`,
        insert: `${API_BASE_URL}/admin/moban/insert`,
        update: `${API_BASE_URL}/admin/moban/update`,
        delete: `${API_BASE_URL}/admin/moban/delete`,
    },
    // 知识库
    knowledge_detail: {
        fetch: `${API_BASE_URL}/admin/knowledge_detail/fetch`,
        scene: `${API_BASE_URL}/admin/knowledge_detail/scene`,
        question: `${API_BASE_URL}/admin/knowledge_detail/question`,
        solution: `${API_BASE_URL}/admin/knowledge_detail/solution`,
        search: `${API_BASE_URL}/admin/knowledge_detail/search`,
        tabsswit: `${API_BASE_URL}/admin/knowledge_detail/tabsswit`,
    },
    // SPU 管理
    spu: {
        fetch: `${API_BASE_URL}/admin/spu/fetch`,
        insert: `${API_BASE_URL}/admin/spu/insert`,
        update: `${API_BASE_URL}/admin/spu/update`,
        delete: `${API_BASE_URL}/admin/spu/delete`,
        filter: `${API_BASE_URL}/admin/spu/filter`,
        isspu_check: `${API_BASE_URL}/admin/spu/isspu_check`,
        enspu: `${API_BASE_URL}/admin/spu/enspu`,
        despu: `${API_BASE_URL}/admin/spu/despu`,
    },
    // 分类管理
    sort_shop: {
        fetch: `${API_BASE_URL}/admin/sort_shop/fetch`,
        insert: `${API_BASE_URL}/admin/sort_shop/insert`,
        update: `${API_BASE_URL}/admin/sort_shop/update`,
        delete: `${API_BASE_URL}/admin/sort_shop/delete_v`,
    },
    // 快捷回复
    quickly_hs: {
        fetch: `${API_BASE_URL}/admin/quickly_hs/fetch`,
        insert: `${API_BASE_URL}/admin/quickly_hs/insert`,
        delete: `${API_BASE_URL}/admin/quickly_hs/delete`,
    },
    // 按键点击
    keyclick: {
        fetch: `${API_BASE_URL}/admin/keyclick/fetch`,
        insert: `${API_BASE_URL}/admin/keyclick/insert`,
        update: `${API_BASE_URL}/admin/keyclick/update`,
        delete: `${API_BASE_URL}/admin/keyclick/delete`,
    },
    // VIP 产品
    vip_products: {
        fetch: `${API_BASE_URL}/admin/vip_products/fetch`,
    },
    // VIP 
    vipcard: {
        fetch: `${API_BASE_URL}/admin/vipcard/fetch`,
        use: `${API_BASE_URL}/admin/vipcard/use`,
    },
    // 购买
    buyshop: {
        insert: `${API_BASE_URL}/admin/buyshop/insert_buyshop.php`,
        alipay: `${API_BASE_URL}/admin/buyshop/buy_alipay.php`,
        update_pay_status: `${API_BASE_URL}/admin/buyshop/update_pay_status.php`,
    },
    // 国家
    country: {
        insert: `${API_BASE_URL}/admin/country/insert`,
    },
    // 我的信息
    myinfo: {
        fetch: `${API_BASE_URL}/admin/myinfo/fetch`,
    },
    // 设置
    beast_setting: {
        fetch: `${API_BASE_URL}/admin/beast_setting/fetch`,
        update: `${API_BASE_URL}/admin/beast_setting/update`,
    },
    // HS 信息
    hs_info: {
        insert: `${API_BASE_URL}/admin/hs_info/insert`,
        update: `${API_BASE_URL}/admin/hs_info/update`,
        delete: `${API_BASE_URL}/admin/hs_info/delete`,
    },
    // Tab 子分
    tab_child_fenlei: {
        update: `${API_BASE_URL}/admin/tab_child_fenlei/update`,
        insert: `${API_BASE_URL}/admin/tab_child_fenlei/insert`,
    },
};

// Employee API 路径
export const EMPLOYEE_API = {
    // 国家
    country: {
        insert: `${API_BASE_URL}/admin/country/insert`,
    },
    // VIP 产品
    vip_products: {
        fetch: `${API_BASE_URL}/admin/vip_products/fetch`,
    },
    // VIP 
    vipcard: {
        fetch: `${API_BASE_URL}/admin/vipcard/fetch`,
        use: `${API_BASE_URL}/admin/vipcard/use`,
    },
    // 购买
    buyshop: {
        insert: `${API_BASE_URL}/admin/buyshop/insert_buyshop.php`,
        alipay: `${API_BASE_URL}/admin/buyshop/buy_alipay.php`,
    },
    // 我的信息
    myinfo: {
        fetch: `${API_BASE_URL}/admin/myinfo/fetch`,
    },
    // 快捷回复
    quickly_hs: {
        fetch: `${API_BASE_URL}/admin/quickly_hs/fetch`,
        insert: `${API_BASE_URL}/admin/quickly_hs/insert`,
        delete: `${API_BASE_URL}/admin/quickly_hs/delete`,
    },
};

// Project API 路径
export const PROJECT_API = {
    vipcard: {
        fetch: `${API_BASE_URL}/project/vipcard/fetch`,
        insert: `${API_BASE_URL}/project/vipcard/insert`,
    },
    update: `${API_BASE_URL}/project/update`,
    deldate: `${API_BASE_URL}/project/deldate`,
    insert: `${API_BASE_URL}/project/insert`,
    soft_info: `${API_BASE_URL}/project/soft_info/insert`,
};

// 通用 API
export const COMMON_API = {
    login: `${API_BASE_URL}/login/index.php`,
    register: `${API_BASE_URL}/register/index_home.php`,
    myinfo: {
        usermessage: `${API_BASE_URL}/function_api/myinfo/usermessage.php`,
        check_country: `${API_BASE_URL}/function_api/myinfo/check_country.php`,
    },
    messages: `${API_BASE_URL}/messages/postData.php`,
};
